<template>
  <div>
   
    <div class="mt-4">
  
      <div class="mb-3">
        <p class="text-primary-yellow font-semibold">
          <span v-if="edit">Intra State</span>
          <span v-else>Coverage Details</span>
        </p>
      </div>
      <!-- <pre>{{route}}</pre> -->
      <div class="flex flex-row flex-wrap lg:flex-nowrap">
        <div class="w-full lg:w-4/12 lg:pr-4">
          <label class="label">State</label>
          <el-select filterable v-model="takeOffLocation" placeholder="Select">
            <el-option
              label="--Select--"
              value="null"
            >
            </el-option>
            <el-option
              v-for="state in states"
              :key="state.id"
              :label="state.name"
              :value="state.name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="w-full lg:w-8/12">
          <div
            class="routes-container flex flex-wrap overflow-hidden max-h-screen transition-all duration-500 pr-2"
            v-for="(route, index) in routes"
            :key="route"
            ref="route"
          >

            <div class="lg:w-1/2 lg:px-2 w-full flex" >
              <img
                  class="cursor-pointer mr-2 lg:hidden"
                  :class="[routes.length > 1 ? 'opacity-100' : 'opacity-25']"
                  @click="removeRoute(index)"
                  src="@/assets/images/icons/delete-icon.svg"
                  alt=""
              />
              <div class="flex gap-2 w-full">
                <img
                  class="cursor-pointer mr-2 hidden lg:block"
                  :class="[routes.length > 1 ? 'opacity-100' : 'opacity-25']"
                  @click="removeRoute(index)"
                  src="@/assets/images/icons/delete-icon.svg"
                  alt=""
                />
                <div :style="{ width: 'inherit'}">
                  <label class="label flex gap-2">
                      Originating Terminal
                  </label>
                  <el-select filterable @change="addTakeOffId(index)" v-model="route.takeOff.id" placeholder="Select">
                    <el-option
                      value="--Select--"
                      >-- Select --
                    </el-option>
                    <el-option
                      v-for="terminal in terminals"
                      :key="terminal"
                      :label="terminal.locationName"
                      :value="terminal.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                
              </div>
              
            </div>

            <div class="w-full lg:w-1/2" :style="{ 'margin-top': '-2.5px' }">
              <label class="label">Destination terminal</label>
              <el-select
                filterable
                @change="addArrivalId(index)"
                v-model="route.arrival.id"
                placeholder="Select"
              >
                <el-option
                  value="--Select--"
                  >-- Select --
                </el-option>
                <el-option
                  v-for="terminal in terminals"
                      :key="terminal"
                      :label="terminal.locationName"
                      :value="terminal.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="flex justify-end">
            <button
              @click="addRoute"
              class="flex w-auto justify-center items-center font-semibold text-primary-yellow"
            >
              <img
                src="@/assets/images/icons/add.svg"
                alt="add icon"
                class="mr-2"
              />
              Add another
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="button-wrapper">
      <p class="cursor-pointer" @click="$router.push({ name: 'Routes' })">
        Cancel
      </p>
      <base-button text="Create Route" :loading = isLoading v-if="!edit" @click="createRoute" />

      <base-button text="Update Route" :loading = isLoading v-else @click="updateRoute" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    states: {
      type: Array,
      default: () => [],
    },

    edit: {
      type: Boolean,
      default: false,
    },
    route: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading:false,
      routeName: "",
      routeMedium: "",
      state: null,
      cities: [],
      terminals:[],
      filteredCities: [],
      terminal: null,
      locations: [],
      takeOffLocation: "",
      routes: [
        {
          takeOff : {
            id: "",
            name: ""
          },
          arrival: {
            id: "",
            name: ""
          }
        },
      ],
    };
  },
  async mounted() {
    await this.getAllLocations();
    if (this.route !== "") {
      let st = this.states.find(
        (state) => state.name == this.route.takeOffLocation
      );
      this.takeOffLocation = st.name;
      let cty = this.route.cities;
      for (let index = 0; index < cty.length; index++) {
        const element = cty[index];
        this.routes=[]
        this.routes=element
      }
      console.log(JSON.stringify(this.routes, null, 2))
    }
  },
  methods: {
    async getAllLocations() {
      try {
        const response = await this.$_getAllLocations();

        this.log(response);
        this.locations = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getTerminalsByState(state) {
      try {
        let response = await this.$_getTerminalsByState(state);
        this.terminals = response.data.getAllTerminals;
      } catch (error) {
        this.handleError(error);
      }
    },
    addRoute() {
      let route = {
        takeOff : {
          id: "",
          name: ""
        },
        arrival: {
          id: "",
          name: ""
        }
      };
      this.routes.push(route);
      this.cities.push([]);
    },
    addTakeOffId(index){
      let terminalId = this.routes[index].takeOff.id
      let terminalName = this.terminals.find(x => x.id == terminalId)?.locationName
      this.routes[index].takeOff.name = terminalName
    },
    addArrivalId(index){
      let terminalId = this.routes[index].arrival.id
      let terminalName = this.terminals.find(x => x.id == terminalId)?.locationName
      this.routes[index].arrival.name = terminalName
    },
    removeRoute(val) {
      if (this.routes.length <= 1) return;
      this.$refs.route[val].classList.add("max-h-zero");
      setTimeout(() => {
        this.routes = this.routes.filter((item, index) => index != val);
      }, 500);
    },

    async createRoute() {
      this.isLoading = true
      let terminalId = this.locations.find(
        (location) => location.state == this.takeOffLocation
      )?.id;
      // lx
      this.payload.payload.referenceTerminal = terminalId;

      try {
        await this.$_createRoute(this.payload);
        this.$router.push({ name: "Routes" });
      } catch (error) {
        this.handleError(error);
      }finally{this.isLoading=false}
    },

    async updateRoute() {
      this.isLoading = true
      let terminalId = this.locations.find(
        (location) => location.state == this.takeOffLocation
      )?.id;
      this.payload.payload.referenceTerminal = terminalId;
      // this.payload.payload.takeOffId = terminalId;
      // this.payload.payload.arrivalId = terminalId;
      try {
        await this.$_updateRoute(this.payload, this.route.id);
        this.$router.push({ name: "Routes" });
      } catch (error) {
        this.handleError(error);
      }finally{this.isLoading=false}
    }, 
  parseObj(data){
return JSON.parse(data)
},
  },

  computed: {
    payload() {
      return {
        payload: {
          orgName:
            this.$store.state.authentication.organizationDetails.companyname,
          isPrimary: true,
          orgId: localStorage.getItem("organizationId"),
          isSecondary: false,
          isIntrastate: true,
          isInternational: false,
          terminalType: "terminal-to-terminal",
          isInterState: false,
          takeOffLocation: this.takeOffLocation,
          arrivalLocation: this.takeOffLocation,
          routes: this.routes,
          referenceTerminal: "",
        },
      };
    },

    referenceTerminals() {
      return this.locations.find((location) => location.state === this.state)
        .id;
    },
  },

  watch: {
    state: {
      handler(val) {
        this.filteredCities = [];
        if (val?.length > 0) {
          this.filteredCities = [
            ...this.states.find((state) => state.name == val).cities,
          ];
        }
      },
    },
    route: {
      deep: true,
      immediate: true,
      handler(route) {
        if (route) {
          (this.routeName = route.routeName),
            (this.routeMedium = route.shippingMethod),
            (this.state = route.state),
            (this.cities = route.cities);
          this.terminal = route.referenceTerminal;
        }
      },
    },
    takeOffLocation: {
      deep: true,
      immediate: true,
      handler(val) {
        this.routes = [
          {
            takeOff : {
              id: "",
              name: ""
            },
            arrival: {
              id: "",
              name: ""
            }
          },
        ];
        if (val != "") {
          this.getTerminalsByState(val)
        }
      },
    },
  
  },
};
</script>

<style>
.max-h-zero {
  max-height: 0;
}
.routes-container {
  animation: 3s 1 linear pop-height;
}
@keyframes pop-height {
  from {
    max-height: 0;
  }
  to {
    max-height: 100vh;
  }
}
</style>
